import { render, staticRenderFns } from "./ChapterForm.vue?vue&type=template&id=4d3e9587&"
import script from "./ChapterForm.vue?vue&type=script&lang=js&"
export * from "./ChapterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports